import {
  configureStore,
  type ThunkAction,
  type Action,
} from "@reduxjs/toolkit";
import midserviceReducer from "./slices/midservice/midserviceSlice";
// import instancesListReducer from "./slices/instancesListSlice";
import userReducer from "./slices/user/userSlice";
import manageUserReducer from "./slices/manageUsers/manageUsersSlice";
import statisticsReducer from "./slices/statistics/statisticsSlice";
import configurationReducer from "./slices/PacketConfiguration/PacketConfigurationSlice";

export const store = configureStore({
  reducer: {
    midservice: midserviceReducer,
    // instancesList: instancesListReducer,
    user: userReducer,
    manageUsers: manageUserReducer,
    statistics: statisticsReducer,
    configuration: configurationReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
